/* Costack PDP extras
 * 15 Sep 2026: THE PACK SELECTOR DELETED ITSELF ON FIRST USE. Picking a pack fires a
 * change on the native select, Dawn re-renders the whole product section through the
 * Section Rendering API, and the injected #cstk-packs block goes with it. The old
 * poller cleared itself the moment the cards existed, so nothing ever rebuilt them.
 * Reproduced on Vegetable Seasoning and Garlic Granules: price updated, cards gone,
 * and no way back to the cheaper pack without a reload. The cards are now rebuilt
 * whenever the select reappears without them, the chosen pack stays highlighted, and
 * sold-out packs are marked instead of being badged MOST POPULAR (Garlic Granules was
 * badging a 5-Pack that cannot be bought).
 * Earlier history worth keeping: the 21 Jul 5-Pack preselect was reverted, every line
 * opens on the cheapest buyable option; Mild Curry ships as a sachet so its first
 * option reads Single sachet, everything else reads as stored.
 */
(function () {
  'use strict';
  if (!/\/products\//.test(location.pathname)) return;
  var handle = location.pathname.split('/products/')[1].split('/')[0].split('?')[0];

  function money(p) { return '£' + (p / 100).toFixed(2); }

  var PACK_LABELS = { 'Single Pack': 'Single sachet', 'Single Sachet': 'Single sachet' };
  function packLabel(v) { return PACK_LABELS[v] || v; }

  var tries = 0;
  var iv = setInterval(function () {
    tries++;
    var head = document.querySelector('.cstk-sets__headrow');
    if (head && !head.querySelector('.cstk-byob-link')) {
      var a = document.createElement('a');
      a.className = 'cstk-sets__all cstk-byob-link';
      a.href = '/pages/build-your-box';
      a.textContent = 'Build your own box';
      a.setAttribute('style', 'margin-left:12px;');
      head.appendChild(a);
      clearInterval(iv);
    }
    if (tries > 40) clearInterval(iv);
  }, 350);

  var CSS = [
    '.cstk-packs{display:flex;flex-direction:column;gap:8px;margin:8px 0 14px;}',
    '.cstk-pk{display:flex;align-items:center;gap:10px;width:100%;text-align:left;border:1.5px solid #e0d5c2;background:#fff;border-radius:10px;padding:11px 13px;cursor:pointer;font-family:inherit;position:relative;}',
    '.cstk-pk.is-sel{border-color:#b3641c;background:#fff8ef;}',
    '.cstk-pk.is-out{opacity:.55;}',
    '.cstk-pk__radio{flex:0 0 auto;width:18px;height:18px;border-radius:50%;border:2px solid #c9bda8;}',
    '.cstk-pk.is-sel .cstk-pk__radio{border-color:#b3641c;background:radial-gradient(#b3641c 42%,#fff 46%);}',
    '.cstk-pk__main{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px;}',
    '.cstk-pk__name{font-size:14px;font-weight:600;color:#231900;}',
    '.cstk-pk__badge{font-size:11px;font-weight:700;color:#1f7a37;}',
    '.cstk-pk__out{font-size:11px;font-weight:700;color:#9a3412;}',
    '.cstk-pk__pop{position:absolute;top:-9px;left:12px;background:#b3641c;color:#fff;font-size:10px;font-weight:700;padding:2px 8px;border-radius:6px;letter-spacing:.3px;}',
    '.cstk-pk__right{flex:0 0 auto;text-align:right;display:flex;flex-direction:column;}',
    '.cstk-pk__price{font-size:15px;font-weight:700;color:#231900;}',
    '.cstk-pk__was{font-size:12px;color:#9a8e78;text-decoration:line-through;}',
    '.cstk-pk__save{font-size:11px;font-weight:700;color:#b3641c;}'
  ].join('');

  var building = false;
  var chosen = null;
  var rebuilds = 0;

  function buildCards() {
    var sel = document.querySelector('select[name="options[Pack]"]');
    if (!sel || building || document.getElementById('cstk-packs')) return;
    var values = [].map.call(sel.options, function (o) { return o.value; });
    if (values.length < 2) return;
    if (++rebuilds > 25) return;

    building = true;

    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (prod) {
        if (document.getElementById('cstk-packs')) { building = false; return; }
        var byPack = {};
        prod.variants.forEach(function (v) { byPack[v.option1] = v; });

        if (!document.getElementById('cstk-packs-css')) {
          var st = document.createElement('style'); st.id = 'cstk-packs-css'; st.textContent = CSS; document.head.appendChild(st);
        }

        var wrap = document.createElement('div'); wrap.id = 'cstk-packs'; wrap.className = 'cstk-packs';
        var firstAvail = null;
        values.forEach(function (val) {
          var v = byPack[val]; if (!v) return;
          var live = !!v.available;
          if (!firstAvail && live) firstAvail = val;
          var price = v.price, was = v.compare_at_price;
          var save = (was && was > price) ? Math.round((1 - price / was) * 100) : 0;
          var free = live && price >= 3500;
          var pop = live && /5-?pack/i.test(val);
          var card = document.createElement('button');
          card.type = 'button';
          card.className = 'cstk-pk' + (live ? '' : ' is-out');
          card.setAttribute('data-pack', val);
          card.innerHTML =
            (pop ? '<span class="cstk-pk__pop">MOST POPULAR</span>' : '')
            + '<span class="cstk-pk__radio" aria-hidden="true"></span>'
            + '<span class="cstk-pk__main"><span class="cstk-pk__name">' + packLabel(val) + '</span>'
            + (live ? (free ? '<span class="cstk-pk__badge">FREE UK delivery</span>' : '') : '<span class="cstk-pk__out">Sold out</span>') + '</span>'
            + '<span class="cstk-pk__right"><span class="cstk-pk__price">' + money(price) + '</span>'
            + (live && save ? '<span class="cstk-pk__was">' + money(was) + '</span><span class="cstk-pk__save">Save ' + save + '%</span>' : '') + '</span>';
          wrap.appendChild(card);
        });

        var box = sel.closest('.product-form__input') || sel.parentNode;
        box.style.display = 'none';
        box.parentNode.insertBefore(wrap, box);

        function selectPack(val) {
          chosen = val;
          if (sel.value !== val) { sel.value = val; sel.dispatchEvent(new Event('change', { bubbles: true })); }
          [].forEach.call(wrap.querySelectorAll('[data-pack]'), function (el) { el.classList.toggle('is-sel', el.getAttribute('data-pack') === val); });
        }
        wrap.addEventListener('click', function (e) {
          var c = e.target.closest('[data-pack]'); if (!c) return;
          selectPack(c.getAttribute('data-pack'));
        });

        selectPack((chosen && byPack[chosen]) ? chosen : (firstAvail || values[0]));
        building = false;
      })
      .catch(function () { building = false; });
  }

  var queued = false;
  function ensureCards() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; if (!document.getElementById('cstk-packs')) buildCards(); }, 60);
  }

  var packTries = 0;
  var packIv = setInterval(function () {
    packTries++;
    if (!document.getElementById('cstk-packs')) buildCards();
    if (packTries > 60) clearInterval(packIv);
  }, 300);

  try { new MutationObserver(ensureCards).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', buildCards);
  else buildCards();
})();

/* Costack PDP popup suppression
 * The SAVE 10% newsletter form buries the buy box on a fresh mobile visit, so it is
 * suppressed on product pages only. Two passes: a light-DOM text scan for the older
 * markup, and a hard hide of <shopify-forms-embed>, whose teaser and popup render
 * inside a shadow root the text scan cannot see.
 * 15 Sep 2026: dropped the old syncSticky block. It looked up #cstk-satc, an id this
 * theme stopped rendering, so it returned on the first line every time. The sticky bar
 * gets its sold-out state from costack-sticky-atc.js.
 */
(function () {
  'use strict';
  if (!/\/products\//.test(location.pathname)) return;

  function isPopup(n) {
    if (!n || n.nodeType !== 1 || !n.querySelector) return false;
    var t = n.textContent || '';
    return /join the costack community|save\s*10%\s*off/i.test(t) && !!n.querySelector('input');
  }
  function unlock() {
    document.body.style.overflow = ''; document.documentElement.style.overflow = '';
    document.body.classList.remove('overflow-hidden');
  }
  function hidePopup(node) {
    var n = node;
    for (var i = 0; i < 7 && n.parentElement; i++) {
      var cs = getComputedStyle(n);
      if (cs.position === 'fixed' || cs.position === 'absolute' || /modal|popup|overlay|drawer/i.test((n.className || '').toString())) break;
      n = n.parentElement;
    }
    (n || node).style.setProperty('display', 'none', 'important');
    unlock();
  }
  function scanPopup(root) {
    if (isPopup(root)) { hidePopup(root); return; }
    if (root.querySelectorAll) {
      var els = root.querySelectorAll('div,section,aside,dialog,form');
      for (var i = 0; i < els.length; i++) { if (isPopup(els[i])) { hidePopup(els[i]); return; } }
    }
  }
  function start() {
    scanPopup(document.body);
    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var a = muts[i].addedNodes || [];
          for (var j = 0; j < a.length; j++) scanPopup(a[j]);
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  try {
    var s = document.createElement('style');
    s.id = 'cstk-popup-kill';
    s.textContent = 'shopify-forms-embed{display:none!important;visibility:hidden!important;}';
    (document.head || document.documentElement).appendChild(s);
  } catch (e) {}
  function kill() {
    try {
      var els = document.querySelectorAll('shopify-forms-embed');
      for (var i = 0; i < els.length; i++) els[i].style.setProperty('display', 'none', 'important');
    } catch (e) {}
  }
  kill();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kill);
  try { new MutationObserver(kill).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
  [300, 1000, 2500, 5000].forEach(function (t) { setTimeout(kill, t); });
})();
